(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-panta-cookie-preferences]');
    if (!button) return;

    const status = document.getElementById(button.getAttribute('aria-describedby'));
    button.disabled = true;
    status.hidden = true;

    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        throw new Error('Shopify cookie preferences are not available');
      }
      await window.privacyBanner.showPreferences();
    } catch {
      status.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
